import type { MouseEvent } from 'react';

import type { MenuHeaderProps } from '~/legacy/types';
import { logoIcons } from '~/legacy/utils';

import Icon from '../Icon';

const menuIconList = {
  soleIcon: {
    fill: '#000000',
    height: '50',
    name: 'sole-icon',
    viewBox: '0 0 58 44',
    width: '50'
  }
};

const MenuHeader = ({
  name,
  headerBack,
  onClose,
  selectedItem,
  showBackButton
}: MenuHeaderProps) => {
  const goBack = () => {
    headerBack && selectedItem && headerBack(selectedItem);
  };

  const closeMenu = (event: MouseEvent) => {
    event.stopPropagation();
    onClose();
  };

  const isMainMenu = !name;

  return (
    <div className="menu-header" onClick={goBack}>
      <div className="menu-header__controls">
        {!showBackButton && (
          <Icon
            onClick={closeMenu}
            name="close"
            width="12"
            height="12"
            viewBox="457 457 878 878"
            fill="black"
            className="menu-header__close"
          />
        )}
        {showBackButton && (
          <Icon
            name="angle-left"
            viewBox="585 425 622 942"
            height="14"
            width="14"
            fill="#333333"
            className="menu-header__angle-left"
          />
        )}
      </div>
      <div className="menu-header__content">
        {isMainMenu ? (
          <Icon {...menuIconList['soleIcon']} className="menu-header__icon" />
        ) : (
          <>
            {selectedItem!.icon && selectedItem!.type !== 'brand' && (
              <Icon
                name={selectedItem!.icon}
                width="25"
                height="25"
                stroke="#a9a9a9"
                fill="#a9a9a9"
                viewBox="0 0 28 26"
              />
            )}
            {selectedItem!.type === 'brand' ? (
              <div className="menu-header__icon">
                <img
                  loading="lazy"
                  alt={selectedItem!.name}
                  src={logoIcons[selectedItem!.icon]}
                />
              </div>
            ) : (
              selectedItem!.displayName || selectedItem!.name
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MenuHeader;
